export default __webpack_public_path__ + "static/media/ic-chevron-up.a716e2b4.svg";